import { render, staticRenderFns } from "./EntityViewConfiguration.vue?vue&type=template&id=80f8e7ee&scoped=true"
import script from "./EntityViewConfiguration.vue?vue&type=script&lang=js"
export * from "./EntityViewConfiguration.vue?vue&type=script&lang=js"
import style0 from "./EntityViewConfiguration.vue?vue&type=style&index=0&id=80f8e7ee&prod&scoped=true&lang=css"
import style1 from "./EntityViewConfiguration.vue?vue&type=style&index=1&id=80f8e7ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f8e7ee",
  null
  
)

export default component.exports